import type { JSX } from 'react'
import { illustrationColors, seasonColors } from './shared'

export function SummerRoofLoad(): JSX.Element {
  const { red, white, paperEdge, coolBox } = seasonColors
  const panelEdges = [156, 169.3, 182.7, 196, 209.3, 222.7, 236]
  const panel = (left: number, right: number) => `M196 66L${left} 90Q${(left + right) / 2} 86 ${right} 90Z`
  return (
    <g>
      <rect x="194.8" y="66" width="2.4" height="50.5" fill={illustrationColors.trim} />
      <rect x="189" y="112.5" width="14" height="4" rx="1.2" fill={illustrationColors.trim} />
      <g stroke={paperEdge} strokeWidth="0.6" strokeLinejoin="round">
        {panelEdges.slice(1).map((right, index) => (
          <path key={right} fill={index % 2 === 0 ? red : white} d={panel(panelEdges[index], right)} />
        ))}
      </g>
      <circle cx="196" cy="65" r="1.8" fill={red} />
      <rect x="226" y="101" width="34" height="15.5" rx="2" fill={coolBox} />
      <rect x="224.5" y="98.5" width="37" height="5" rx="1.6" fill={white} stroke={paperEdge} strokeWidth="0.6" />
      <path
        d="M236 98.5V95.6Q236 94 237.6 94H248.4Q250 94 250 95.6V98.5"
        fill="none"
        stroke={illustrationColors.trim}
        strokeWidth="1.4"
      />
    </g>
  )
}
